import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "indexPage"
}
const _hoisted_2 = { class: "filterModalWrap" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "filterTitle" }
const _hoisted_5 = { for: "searchFilterInput" }
const _hoisted_6 = { class: "searchInputFilterWrapper" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = {
  key: 0,
  class: "searchInputErrorMessage"
}
const _hoisted_11 = { class: "panelResults" }
const _hoisted_12 = {
  key: 0,
  class: "filterItemsResultsWrapper"
}
const _hoisted_13 = { class: "applyButton setting-closeButton" }
const _hoisted_14 = { class: "indexFilter" }
const _hoisted_15 = { class: "container" }
const _hoisted_16 = { class: "inner" }
const _hoisted_17 = {
  key: 0,
  class: "filters"
}
const _hoisted_18 = ["aria-label"]
const _hoisted_19 = { class: "container" }
const _hoisted_20 = { class: "inner" }
const _hoisted_21 = { class: "filterItemsWrapper" }
const _hoisted_22 = { class: "generalIndexResults background-beige" }
const _hoisted_23 = { class: "container" }
const _hoisted_24 = {
  key: 0,
  class: "noResults"
}
const _hoisted_25 = {
  key: 1,
  class: "error"
}
const _hoisted_26 = {
  key: 2,
  class: "itemContainer"
}
const _hoisted_27 = {
  key: 3,
  class: "splide"
}
const _hoisted_28 = {
  key: 4,
  class: "loading"
}
const _hoisted_29 = { class: "container" }
const _hoisted_30 = { class: "wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Filters = _resolveComponent("Filters")!
  const _component_ChosenTags = _resolveComponent("ChosenTags")!
  const _component_SortOrderDropDown = _resolveComponent("SortOrderDropDown")!
  const _component_ResultItemsContainer = _resolveComponent("ResultItemsContainer")!
  const _component_ResultsIndicator = _resolveComponent("ResultsIndicator")!
  const _component_RenderResources = _resolveComponent("RenderResources")!
  const _component_RenderSettings = _resolveComponent("RenderSettings")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RenderSettings, {
      parentid: _ctx.parentid,
      endPoint: _ctx.apiendpoint,
      culture: _ctx.language
    }, {
      settings: _withCtx(({ settings }) => [
        _createElementVNode("div", _hoisted_2, [
          (
              settings.taxonomy?.tagGroups.length > 0 ||
                settings.enableKeywordSearch
            )
            ? _withDirectives((_openBlock(), _createElementBlock("form", {
                key: 0,
                class: _normalizeClass(["indexFiltersModal", !settings.enableKeywordSearch ? 'noKeywordSearch' : '']),
                id: "indexFilterPanelControl",
                role: "region",
                "aria-labelledby": "indexFilterPanelID",
                "aria-hidden": "true",
                onSubmit: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"])),
                ref: "panelContent",
                onKeydown: _cache[13] || (_cache[13] = _withKeys(
//@ts-ignore
(...args) => (_ctx.panelEsc && _ctx.panelEsc(...args)), ["esc"]))
              }, [
                _createElementVNode("button", {
                  class: "filterModalClose",
                  "aria-label": _ctx.$t('Web.Aria.CloseFilters'),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterSidebarCloseClick && _ctx.filterSidebarCloseClick(...args))),
                  ref: "filterModalClose"
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("Web.Containers.Close")) + " ", 1),
                  _cache[20] || (_cache[20] = _createElementVNode("svg", {
                    width: "12",
                    height: "13",
                    viewBox: "0 0 12 13",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      d: "M1 11.5L11 1.5M1 1.5L11 11.5",
                      stroke: "#2D3232",
                      "stroke-width": "1.67",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1))
                ], 8, _hoisted_3),
                (settings.enableKeywordSearch)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["filterTitleWrapper", settings.taxonomy.tagGroups.length > 0 ? '' : 'noFilters'])
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _cache[21] || (_cache[21] = _createElementVNode("svg", {
                          role: "img",
                          "aria-hidden": "true",
                          width: "20",
                          height: "17",
                          viewBox: "0 0 20 17",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("rect", {
                            x: "2",
                            width: "2",
                            height: "17",
                            fill: "#2D3232"
                          }),
                          _createElementVNode("rect", {
                            x: "9",
                            width: "2",
                            height: "17",
                            fill: "#2D3232"
                          }),
                          _createElementVNode("rect", {
                            x: "16",
                            width: "2",
                            height: "17",
                            fill: "#2D3232"
                          }),
                          _createElementVNode("rect", {
                            x: "1",
                            y: "3",
                            width: "4",
                            height: "4",
                            fill: "#E0D4C8",
                            stroke: "#2D3232",
                            "stroke-width": "2"
                          }),
                          _createElementVNode("rect", {
                            x: "8",
                            y: "12",
                            width: "4",
                            height: "4",
                            fill: "#E0D4C8",
                            stroke: "#2D3232",
                            "stroke-width": "2"
                          }),
                          _createElementVNode("rect", {
                            x: "15",
                            y: "1",
                            width: "4",
                            height: "4",
                            fill: "#E0D4C8",
                            stroke: "#2D3232",
                            "stroke-width": "2"
                          })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("Web.Containers.Filter")), 1)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["searchInput", _ctx.keywordError && 'searchError'])
                      }, [
                        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("Web.Containers.SearchLabel")), 1),
                        _createElementVNode("div", _hoisted_6, [
                          _withDirectives(_createElementVNode("input", {
                            id: "searchFilterInput",
                            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)), ["prevent"]), ["enter"])),
                            type: "search",
                            placeholder: _ctx.$t('Web.Containers.SearchPlaceholder'),
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.keyword) = $event)),
                            autocomplete: "off"
                          }, null, 40, _hoisted_7), [
                            [_vModelText, _ctx.keyword]
                          ]),
                          (_ctx.keyword.length > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "clearButton",
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearKeyword && _ctx.clearKeyword(...args))),
                                "aria-label": _ctx.$t('Web.Containers.ClearKeyword')
                              }, [...(_cache[22] || (_cache[22] = [
                                _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "19",
                                  height: "18",
                                  viewBox: "0 0 19 18",
                                  preserveAspectRatio: "xMinYMid",
                                  "aria-hidden": "true",
                                  role: "img",
                                  fill: "#1A1347"
                                }, [
                                  _createElementVNode("g", null, [
                                    _createElementVNode("path", {
                                      d: "M315.25 20.25V31H326v1.5h-10.75v10.75h-1.5V32.5H303V31h10.75V20.25h1.5z",
                                      transform: "translate(-305 -79) translate(0 56) rotate(45 314.5 31.75)"
                                    })
                                  ])
                                ], -1)
                              ]))], 8, _hoisted_8))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "searchButton",
                            "aria-label": _ctx.$t('Web.Containers.SearchButtonAria'),
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                          }, [...(_cache[23] || (_cache[23] = [
                            _createElementVNode("svg", {
                              role: "img",
                              "ariah-hidden": "true",
                              width: "17",
                              height: "17",
                              viewBox: "0 0 17 17",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                d: "M16 16L11 11M12.6667 6.83333C12.6667 10.055 10.055 12.6667 6.83333 12.6667C3.61167 12.6667 1 10.055 1 6.83333C1 3.61167 3.61167 1 6.83333 1C10.055 1 12.6667 3.61167 12.6667 6.83333Z",
                                stroke: "#2D3232",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              })
                            ], -1)
                          ]))], 8, _hoisted_9)
                        ]),
                        (_ctx.keywordError)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t("Web.Containers.SearchErrorKeywordLength")), 1))
                          : _createCommentVNode("", true)
                      ], 2)
                    ], 2))
                  : _createCommentVNode("", true),
                (settings.taxonomy.tagGroups.length > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "indexFiltersInner",
                      tabindex: "1",
                      onKeydown: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                    }, [
                      _createVNode(_component_Filters, {
                        tagGroups: settings.taxonomy?.tagGroups,
                        onSelectedTagsUpdated: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateCurrentSelectedTags($event))),
                        onTagUpdated: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateTags($event))),
                        selectedTags: _ctx.currentSelectedTags,
                        class: "selectWrapper"
                      }, null, 8, ["tagGroups", "selectedTags"]),
                      _createElementVNode("div", _hoisted_11, [
                        (_ctx.currentSelectedTags.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _cache[24] || (_cache[24] = _createElementVNode("p", null, "Applied filters:", -1)),
                              _createVNode(_component_ChosenTags, {
                                tags: _ctx.currentSelectedTags,
                                onClearTag: _cache[7] || (_cache[7] = 
                      (tag) => {
                        _ctx.currentSelectedTags.splice(
                          _ctx.currentSelectedTags.indexOf(tag),
                          1
                        );
                      }
                    )
                              }, null, 8, ["tags"]),
                              (_ctx.tags.length > 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "clearAll",
                                    onClick: _cache[8] || (_cache[8] = 
                      () => {
                        _ctx.currentSelectedTags = [];
                      }
                    )
                                  }, _toDisplayString(_ctx.$t("Web.Containers.ClearAll")), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("button", {
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args))),
                            onKeydown: _cache[10] || (_cache[10] = _withKeys(
//@ts-ignore
(...args) => (_ctx.lastFocusTab && _ctx.lastFocusTab(...args)), ["tab"]))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("Web.Containers.Apply")) + " ", 1),
                            _cache[25] || (_cache[25] = _createElementVNode("svg", {
                              role: "img",
                              "aria-hidden": "true",
                              width: "7",
                              height: "13",
                              viewBox: "0 0 7 13",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                d: "M1 1.5L6 6.5L1 11.5",
                                stroke: "white",
                                "stroke-width": "1.67",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              })
                            ], -1))
                          ], 32)
                        ])
                      ])
                    ], 32))
                  : _createCommentVNode("", true)
              ], 34)), [
                [_directive_click_outside, _ctx.onClickOutsideFilterPanel]
              ])
            : _createCommentVNode("", true),
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "overlay" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
              (
                  settings?.sortOrder?.length > 0 ||
                    settings.enableKeywordSearch ||
                    settings.taxonomy?.tagGroups.length > 0
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (settings?.sortOrder.length > 1)
                      ? (_openBlock(), _createBlock(_component_SortOrderDropDown, {
                          key: 0,
                          dropdownId: 'indexSortBy',
                          options: settings?.sortOrder,
                          label: 'Sort by',
                          onSortOrderChange: _ctx.updateSortData
                        }, null, 8, ["options", "onSortOrderChange"]))
                      : _createCommentVNode("", true),
                    (
                    settings.enableKeywordSearch ||
                      settings.taxonomy?.tagGroups.length > 0
                  )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          "aria-expanded": "false",
                          "aria-controls": "indexFilterPanelControl",
                          id: "indexFilterPanelID",
                          "aria-label": _ctx.$t('Web.Aria.OpenFilters'),
                          ref: "panelButton",
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.filterSidebarClick && _ctx.filterSidebarClick(...args)))
                        }, [
                          _cache[27] || (_cache[27] = _createElementVNode("svg", {
                            role: "img",
                            "aria-hidden": "true",
                            width: "20",
                            height: "17",
                            viewBox: "0 0 20 17",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("rect", {
                              x: "2",
                              width: "2",
                              height: "17",
                              fill: "#2D3232"
                            }),
                            _createElementVNode("rect", {
                              x: "9",
                              width: "2",
                              height: "17",
                              fill: "#2D3232"
                            }),
                            _createElementVNode("rect", {
                              x: "16",
                              width: "2",
                              height: "17",
                              fill: "#2D3232"
                            }),
                            _createElementVNode("rect", {
                              x: "1",
                              y: "3",
                              width: "4",
                              height: "4",
                              fill: "#E0D4C8",
                              stroke: "#2D3232",
                              "stroke-width": "2"
                            }),
                            _createElementVNode("rect", {
                              x: "8",
                              y: "12",
                              width: "4",
                              height: "4",
                              fill: "#E0D4C8",
                              stroke: "#2D3232",
                              "stroke-width": "2"
                            }),
                            _createElementVNode("rect", {
                              x: "15",
                              y: "1",
                              width: "4",
                              height: "4",
                              fill: "#E0D4C8",
                              stroke: "#2D3232",
                              "stroke-width": "2"
                            })
                          ], -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.getSearchButtonText(settings)), 1)
                        ], 8, _hoisted_18))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (_ctx.tags.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "appliedResults",
              "on:clearTag": _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.clearTag && _ctx.clearTag(...args)))
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  (_ctx.tags.length > 0)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        "on:clearTag": _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.clearTag && _ctx.clearTag(...args)))
                      }, _toDisplayString(_ctx.$t("Web.Containers.AppliedFilters")) + ": ", 33))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_ChosenTags, {
                      tags: _ctx.tags,
                      onClearTag: _ctx.clearTag
                    }, null, 8, ["tags", "onClearTag"]),
                    (_ctx.tags.length > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "clearAll",
                          onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.clearAllTags && _ctx.clearAllTags(...args)))
                        }, _toDisplayString(_ctx.$t("Web.Containers.ClearAll")), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 32))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_RenderResources, {
            parentid: _ctx.parentid,
            endPoint: _ctx.apiendpoint,
            tags: _ctx.selectedTags,
            images: _ctx.images,
            additionalFields: _ctx.additionalFields,
            additionalFieldsMultiLingual: _ctx.additionalFieldsMultiLingual,
            page: _ctx.currentActivePage,
            keyword: _ctx.keywordInput,
            pagesize: _ctx.pagesize,
            sortOrder: _ctx.sortOrder,
            sortType: _ctx.sortType,
            sortIsDesc: _ctx.sortIsDesc,
            language: _ctx.language,
            personalisationGroupIds: _ctx.personalisationGroupIds,
            onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.resourcesChanged($event, _ctx.pagesize)))
          }, {
            search: _withCtx(({ result, loading, error }) => [
              _createElementVNode("div", _hoisted_23, [
                (
                    !loading &&
                      !error &&
                      (result === undefined ||
                        result.results === undefined ||
                        result.results.length === 0)
                  )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _cache[28] || (_cache[28] = _createElementVNode("svg", {
                        role: "img",
                        "aria-hidden": "true",
                        width: "91",
                        height: "91",
                        viewBox: "0 0 91 91",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M65.9175 65.9172L88.9999 88.9997",
                          stroke: "#2D3232",
                          "stroke-width": "5",
                          "stroke-miterlimit": "10"
                        }),
                        _createElementVNode("path", {
                          d: "M39.8572 76.7144C60.2129 76.7144 76.7144 60.2129 76.7144 39.8572C76.7144 19.5015 60.2129 3 39.8572 3C19.5015 3 3 19.5015 3 39.8572C3 60.2129 19.5015 76.7144 39.8572 76.7144Z",
                          stroke: "#2D3232",
                          "stroke-width": "5",
                          "stroke-miterlimit": "10"
                        }),
                        _createElementVNode("path", {
                          d: "M56.7415 26.5205H49.9971V33.265H56.7415V26.5205Z",
                          fill: "#2D3232"
                        }),
                        _createElementVNode("path", {
                          d: "M49.9334 20.0166H43.189V26.7611H49.9334V20.0166Z",
                          fill: "#2D3232"
                        }),
                        _createElementVNode("path", {
                          d: "M49.9334 33.187H43.189V39.9315H49.9334V33.187Z",
                          fill: "#2D3232"
                        }),
                        _createElementVNode("path", {
                          d: "M36.5164 19.8542H29.772V26.5987H36.5164V19.8542Z",
                          fill: "#2D3232"
                        }),
                        _createElementVNode("path", {
                          d: "M29.7718 26.5986H23.0273V33.3431H29.7718V26.5986Z",
                          fill: "#2D3232"
                        }),
                        _createElementVNode("path", {
                          d: "M43.1922 39.8533H36.4478V46.5977H43.1922V39.8533Z",
                          fill: "#2D3232"
                        }),
                        _createElementVNode("path", {
                          d: "M43.1922 59.6899H36.4478V66.4344H43.1922V59.6899Z",
                          fill: "#2D3232"
                        }),
                        _createElementVNode("path", {
                          d: "M43.1922 46.5198H36.4478V53.2642H43.1922V46.5198Z",
                          fill: "#2D3232"
                        }),
                        _createElementVNode("path", {
                          d: "M43.1922 13.3501H36.4478V20.0946H43.1922V13.3501Z",
                          fill: "#2D3232"
                        })
                      ], -1)),
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Web.Containers.NoResultsTitle")), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("Web.Containers.NoResultsText")), 1)
                    ]))
                  : _createCommentVNode("", true),
                error
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.$t("Web.Containers.LoadingResourceError")), 1))
                  : _createCommentVNode("", true),
                (_ctx.resultType === 'ResultArticles')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      (
                      !error &&
                        result.results !== undefined &&
                        result.results.length > 0
                    )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["itemInner", _ctx.resultType])
                          }, [
                            _createVNode(_component_ResultItemsContainer, {
                              results: result,
                              ctas: settings.ctas,
                              ctaFrequency: settings.ctaFrequency,
                              resultType: _ctx.resultType,
                              language: _ctx.language,
                              defaultSiteImageUrl: settings.defaultSiteImageUrl
                            }, null, 8, ["results", "ctas", "ctaFrequency", "resultType", "language", "defaultSiteImageUrl"])
                          ], 2))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      (
                      !error &&
                        result.results !== undefined &&
                        result.results.length > 0
                    )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["splide__track", _ctx.resultType])
                          }, [
                            _createVNode(_component_ResultItemsContainer, {
                              results: result,
                              ctas: settings.ctas,
                              ctaFrequency: settings.ctaFrequency,
                              resultType: _ctx.resultType,
                              language: _ctx.language,
                              defaultSiteImageUrl: settings.defaultSiteImageUrl
                            }, null, 8, ["results", "ctas", "ctaFrequency", "resultType", "language", "defaultSiteImageUrl"])
                          ], 2))
                        : _createCommentVNode("", true)
                    ])),
                (loading && !error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("Web.Containers.LoadingResults")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.currentActivePage < _ctx.totalPages)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["resultsAndButton", _ctx.resultType])
                  }, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        (result.totalResults > 0)
                          ? (_openBlock(), _createBlock(_component_ResultsIndicator, {
                              key: 0,
                              first: _ctx.firstPage(_ctx.currentActivePage, _ctx.pagesize),
                              term: _ctx.keywordInput,
                              last: _ctx.lastPage(result.totalResults, _ctx.pagesize),
                              total: result.totalResults,
                              indexTitle: _ctx.title
                            }, null, 8, ["first", "term", "last", "total", "indexTitle"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          onClick: _cache[18] || (_cache[18] = 
                        (evt) => {
                          evt.preventDefault();
                          _ctx.paginationClick(_ctx.currentActivePage + 1);
                        }
                      )
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.$t("Web.Containers.ShowMore")) + " ", 1),
                          _cache[29] || (_cache[29] = _createElementVNode("svg", {
                            role: "img",
                            "aria-hidden": "true",
                            width: "12",
                            height: "8",
                            viewBox: "0 0 12 8",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              d: "M11 1.5L6 6.5L1 1.5",
                              stroke: "white",
                              "stroke-width": "1.67",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            })
                          ], -1))
                        ])
                      ])
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["parentid", "endPoint", "tags", "images", "additionalFields", "additionalFieldsMultiLingual", "page", "keyword", "pagesize", "sortOrder", "sortType", "sortIsDesc", "language", "personalisationGroupIds"])
        ])
      ]),
      _: 1
    }, 8, ["parentid", "endPoint", "culture"])
  ]))
}